import { FormattedText, ParaTag, SpanTag } from "@tm/static";
import { theme } from "@tm/utility/global";
import { TextNodeType } from "../FormattedText/FormattedText";

import {
  OrderDetailsItem,
  OrderDetailsTable as OrderDetailsTableStyle,
} from "./OrderDetailComp.style";

export interface OrderDetailsTableProps {
  orderDetails?: {
    label?: string | TextNodeType;
    value?: string | TextNodeType;
  }[];
}

const OrderDetailsTable = ({ orderDetails }: OrderDetailsTableProps) => {
  return (
    <OrderDetailsTableStyle>
      {orderDetails?.map((item, index) => {
        return (
          <OrderDetailsItem gap="16px" key={index}>
            {item.label && (
              <ParaTag
                textTransform="uppercase"
                color={theme.greyText7}
                fontSize="xs"
              >
                <FormattedText value={item.label} />
              </ParaTag>
            )}
            <SpanTag
              fontSize="xs"
              fontWeight="bold"
              style={{ textAlign: "left" }}
            >
              <FormattedText value={item.value} />
            </SpanTag>
          </OrderDetailsItem>
        );
      })}
    </OrderDetailsTableStyle>
  );
};

export default OrderDetailsTable;
